export function formatPlanPrice(plan: {
  price: number | null;
  price_label?: string;
  period?: string;
}): string {
  if (plan.price_label) {
    return plan.price_label;
  }
  if (plan.price === null) {
    return 'Custom';
  }
  if (plan.price === 0) {
    return 'Free';
  }
  return Number.isInteger(plan.price)
    ? `$${plan.price}`
    : `$${plan.price.toFixed(1)}`;
}

export function formatLimitValue(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return 'Unlimited';
  }
  return String(value);
}

export function isPaidPlan(plan: {
  price: number | null;
  price_label?: string;
}): boolean {
  if (plan.price_label) {
    return false;
  }
  return plan.price !== null && plan.price > 0;
}

export function isFreePlan(plan: { slug?: string } | null | undefined): boolean {
  return !plan || plan.slug === 'free';
}

/** Store manager is available on paid plans only. */
export function canAccessStores(
  plan: { slug?: string } | null | undefined
): boolean {
  return !isFreePlan(plan);
}

export function hasAnalytics(
  plan: { limits?: { analytics_enabled?: boolean } } | null | undefined
): boolean {
  return !!plan?.limits?.analytics_enabled;
}

export function canUseCustomButtonColors(
  plan: { limits?: { custom_button_colors?: boolean } } | null | undefined
): boolean {
  return !!plan?.limits?.custom_button_colors;
}

export function canCreateLinkProfile(
  plan: { limits?: { max_link_profiles?: number | null } } | null | undefined,
  currentCount: number
): boolean {
  const max = plan?.limits?.max_link_profiles;
  if (max === null || max === undefined) {
    return true;
  }
  return currentCount < max;
}

export const PENDING_CHECKOUT_STORAGE_KEY = 'vioo_pending_checkout_session';
